module.exports = __webpack_public_path__ + "static/img/help_06intro_12.a10af95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stufdback/help_06intro_12.png
// module id = 725
// module chunks = 140